import { AppRoutes } from "./router";
import { BrowserRouter } from "react-router-dom";
import Footer from "./components/feature/Footer";

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <div className="min-h-screen flex flex-col">
        <main className="flex-grow">
          <AppRoutes />
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
